import { render } from "./QuestionPracticeCard.vue?vue&type=template&id=5c56c31a&scoped=true"
import script from "./QuestionPracticeCard.vue?vue&type=script&lang=js"
export * from "./QuestionPracticeCard.vue?vue&type=script&lang=js"

import "./QuestionPracticeCard.vue?vue&type=style&index=0&id=5c56c31a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c56c31a"]])

export default __exports__